module.exports = __webpack_public_path__ + "management.Wc6qScpN.svg";